import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import {
  deleteLsBothTokens,
  deleteLsFeaturesEnrollmentPlanner,
  deleteLsUserRoleObject,
  deleteReportingFilters,
  removeCurrentNote
} from '../../modules/networkTools/localStorageTokens';
import { MSG_ACTIVATION_SUCCESS } from '../../utils/errorMessages';
import { notifyUserError, notifyUserSuccess } from '../../utils/notifications';
import {
  postLoginUser,
  postLogoutUser,
  postRegisterUser,
  postSetupPasswordOnInvite
} from './authActions';

type UserProps = {
  firstName: string;
  lastName: string;
  email: string;
  phone: string;
  password: string;
  confirmPassword: string;

  forceReset?: boolean;
  resetPasswordBy: 'email';
  code: string;
};

export interface AuthSliceProps {
  user: UserProps;
  loading: boolean;
  success: boolean;
  error: string | null | undefined;
}

const initialState: AuthSliceProps = {
  user: {
    firstName: '',
    lastName: '',
    email: '',
    phone: '',
    password: '',
    confirmPassword: '',

    resetPasswordBy: 'email',
    code: ''
  },
  loading: false,
  error: null,
  success: false
};

export const authSlice = createSlice({
  name: 'authSlice',
  initialState,
  reducers: {
    resetStatuses: (state) => {
      state.success = false;
      state.loading = false;
      state.error = null;
    },

    updateUserData: (state, action: PayloadAction<UserProps>) => {
      state.user = { ...state.user, ...action.payload };
    },

    logout: (state) => {
      deleteLsBothTokens();
      deleteLsUserRoleObject();
      deleteReportingFilters();
      deleteLsFeaturesEnrollmentPlanner();
      state.user = { ...state.user, email: '', password: '' };
      state.success = false;
      state.loading = false;
      state.error = null;
    }
  },
  extraReducers: (builder) => {
    builder //getResetPasswordCode

      .addCase(postRegisterUser.fulfilled, (state) => {})
      .addCase(postRegisterUser.rejected, (state, { error, payload }) => {
        notifyUserError(payload);
      }) //postLoginUser
      .addCase(postLoginUser.fulfilled, (state, { payload }) => {})
      .addCase(postLoginUser.rejected, (state, { error, payload }: any) => {}) //putLogoutUser
      .addCase(postLogoutUser.fulfilled, (_, { payload }) => {
        // ON  LOGOUT REMOVE ACTUAL NOTE ID FROM LS
        removeCurrentNote();
      })
      .addCase(postLogoutUser.rejected, (_, { payload }) => {
        notifyUserError(payload);
      })
      .addCase(postSetupPasswordOnInvite.fulfilled, (state, { payload }) => {
        notifyUserSuccess(MSG_ACTIVATION_SUCCESS);
      })
      .addCase(postSetupPasswordOnInvite.rejected, (state, { error, payload }: any) => {
        notifyUserError(payload?.[0]?.message);
      });
  }
});

export const { updateUserData, logout } = authSlice.actions;

export default authSlice.reducer;
